import { mutations } from "./const";
export default {
  [mutations.SET_TIME_TO_EXPIRED](state, payload) {
    state.timeToExpired = payload;
  },
  [mutations.SET_IS_EXPIRED](state, payload) {
    state.isExpired = payload;
  },
};
